<template>
  <div class="ibs-return-container-style">
    <!-- 退换货办理 -->
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div class="tip-title">
          <el-breadcrumb-item>
            <div class="tips-title-style">
              {{ isReturn ? '退货' : '换货' }}合同详情
            </div>
          </el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <BaseInfoInterCheck :info="info" :is-return="isReturn" />
    <rj-tabs ref="rjTabs" v-model="tabsActive">
      <rj-tab-pane v-if="!isReturn" name="1" label="合同明细">
        <contractual-detailed ref="detailedRef" :product-table="productTable" :str-contract-code="contractNum" :contract-id="info.contractId" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isReturn" name="2" label="订单明细">
        <contractual-product :str-contract-code="contractNum" :sales-type="info.salesType" :old-contract-num-code="info.oldContractNum" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isReturn" name="3" label="约定交付日期">
        <delivery-date :str-contract-code="contractNum" :contract-id="info.contractId" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isReturn" name="4" label="发货明细">
        <logistics-info :str-contract-code="contractNum" :contract-id="info.contractId" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isReturn" name="5" label="序列号明细">
        <serial-number :str-contract-code="contractNum" />
      </rj-tab-pane>
      <rj-tab-pane v-if="!isReturn" name="6" label="开票明细">
        <invoice-details :str-contract-code="contractNum" :project-name="info.projectName" :contract-id="info.contractId" />
      </rj-tab-pane>
      <rj-tab-pane v-if="isReturn" name="7" label="退货明细">
        <el-table :data="productTable" border style="width: 100%">
          <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
          <el-table-column
            prop="erpLineNum"
            label="ERP行号"
            align="left"
          />

          <el-table-column
            prop="productCode"
            label="销售产品代码"
            align="left"
          />
          <el-table-column
            prop="productSalesName"
            label="商品名称"
            align="left"
            width="180"
          />
          <el-table-column
            prop="productName"
            label="产品型号"
            align="left"
            width="180"
          />
          <el-table-column
            prop="materialNum"
            label="物料编码"
            align="left"
            width="180"
          />
          <el-table-column
            prop="materialUnit"
            label="单位"
            align="left"
            width="180"
          />
          <el-table-column
            prop="productNum"
            label="数量"
            align="left"
            width="180"
          >
            <template slot-scope="{ row }">
              {{ row.productNum }}
            </template>
          </el-table-column>
          <el-table-column
            prop="productPrice"
            label="单价"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="productPriceAdd"
            label="订单金额"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="productActualPriceAdd"
            label="实际结算金额"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="beforeSplitPrice"
            label="拆分前单价"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="storageName"
            label="库位"
            align="left"
            width="180"
          />
          <el-table-column
            prop="fictitiousReturn"
            label="真实/虚拟退货"
            align="left"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.fictitiousReturn">真实退</span>
              <span v-if="!scope.row.fictitiousReturn">虚拟退</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taxRate"
            label="税率"
            align="right"
            header-align="left"
            width="120"
          />
        </el-table>
      </rj-tab-pane>
      <rj-tab-pane name="8" label="分配明细">
        <pay-for-details :contract-id="info.contractId" :contract-status="info.contractStatus" :info-table-data="info" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>

<script>
import BaseInfoInterCheck from './InternationalChange/BaseInfoInterCheck';
import ContractualDetailed from './InternationalChange/ContractualDetailed';
import ContractualProduct from './InternationalChange/ContractualProduct';
import LogisticsInfo from './InternationalChange/LogisticsInfo';
import SerialNumber from './InternationalChange/SerialNumber';
import DeliveryDate from './InternationalChange/DeliveryDate';
import InvoiceDetails from './InternationalChange/InvoiceDetails';
import payForDetails from './InternationalChange/payForDetails';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import { getDoneReplacementDetailData, getDoneReturnDetailData } from '@/API';
import { MathAdd, MathMulti } from '@/libs/util';

export default {
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    BaseInfoInterCheck,
    ContractualDetailed,
    ContractualProduct,
    LogisticsInfo,
    SerialNumber,
    DeliveryDate,
    InvoiceDetails,
    payForDetails
  },

  data () {
    return {
      tabsActive: '',
      contractNum: '',
      info: {},
      productTable: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      isReturn: false
    };
  },
  props: {

  },
  mounted () {
    this.init();
  },
  methods: {

    // 分配明细 合计
    getDistributionSummaries (param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '已分配金额') {
          sums[index] = data.reduce((pre, cur) => MathAdd(pre, cur.rassignAmount), 0);
          return;
        }
        if (column.label === '已分配金额比例') {
          sums[index] = data.reduce((pre, cur) => {
            let num = cur.distributionProportion >= 100 ? 100 : cur.distributionProportion;
            return MathAdd(pre, num);
          }, 0) + '%';
        }
      });
      return sums;
    },

    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.rproductNumAmount(param.data);
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.rproductPriceAddAmount(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.rproductActualPriceAddAmount(param.data);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.rbeforeSplitPriceAmount(param.data);
        }
      });
      return sums;
    },
    rproductNumAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductNum);
      });
      return `-${cont}`;
    },
    rproductPriceAddAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductPriceAdd);
      });
      return `-${cont.toFixed(2)}`;
    },
    rbeforeSplitPriceAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, MathMulti(item.rbeforeSplitPrice, Number(item.rproductNum)));
      });
      return `-${cont.toFixed(2)}`;
    },
    rproductActualPriceAddAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductActualPriceAdd);
      });
      // this.allCont = cont;
      return `-${cont.toFixed(2)}`;
    },
    init () {
      this.contractNum = this.$route.query.number;
      this.isReturn = this.$route.query.contractType.includes('退货合同');
      if (this.$refs.rjTabs) {
        if (this.$route.query.contractType.includes('退货')) {
          this.$refs.rjTabs.currentName = '7';
        } else {
          this.$refs.rjTabs.currentName = '1';
        }
      }
      this.initData();
    },
    async initData () {
      let res;
      const parmas = {
        contractId: this.$route.query.contractId
      };
      if (this.$route.query.contractType.includes('退货合同')) {
        res = await getDoneReturnDetailData(parmas);
      } else {
        res = await getDoneReplacementDetailData(parmas);
      }
      const json2 = res.data;
      if (json2.status === '200') {
        this.$nextTick(() => {
          this.productTable = json2.data.product;
          this.info = { ...json2.data.base, ...json2.data.detail, ...json2.data.customer };
          this.tableData2 = json2.data || [];
          if (this.tableData2?.length) {
            this.tableData2.forEach((item) => {
              item.rrefundAmount = this.info.rrefundAmount;
              item.ractualSettlementAmount = this.info.ractualSettlementAmount;
              item.rorderMoney = this.info.rorderMoney;
            });
          }
        });
      }
    }
  }

};
</script>

<style scope lang="scss">
.ibs-return-container-style{
  .rj-breadcrumb{
  display: flex;
  justify-content: center;
  }
  .tips-title-style{
    font-size: 20px;
    font-weight: 700;
    color: #303133;
  }
}

</style>
